import { Directive } from "@angular/core";

import { Base } from "./base";

@Directive()
export abstract class BaseComponent extends Base {
    constructor() {
        super();
        this.log.debug("Component initialized");
    }
}
